var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-button',{class:[_vm.getTypeClass, this.size],attrs:{"type":_vm.getType,"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[(!_vm.text)?_vm._t("default"):_vm._e(),_vm._v(" "+_vm._s(_vm.text)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }